import request from '@/utils/request';

export type AgentListItem = {
  id: number;
  name: string;
  username?: string | null;
  status?: string | null;
};

export function getAgents(params?: Record<string, any>) {
  return request({
    url: '/agents',
    method: 'get',
    params,
  });
}


